// extracted by mini-css-extract-plugin
module.exports = {"container":"_3h0YfUkIIyiBMxUWqwJLze","row":"M9DmW0qo-xxJTsEjbq_WG","input":"_1jdoiGSFrX27W3yvcr_DIK","infoWrapper":"_3Biu-m1k_3-aE5AuLW6r1d","icon":"_56i0No_Mvbrk4MwF285Nw"};